// extracted by mini-css-extract-plugin
module.exports = {"drawer_body_class":"DealerOtherBranchesDrawer_drawer_body_class__jClNY","drawer_warning_icon":"DealerOtherBranchesDrawer_drawer_warning_icon__Vgdf3"};